import { CaretRightOutlined, RightOutlined ,  CheckCircleTwoTone , PrinterOutlined , EyeOutlined , PlusOutlined } from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Alert,
  notification,
  Typography,
  Space,
  Spin,
  Card,
  Avatar,
  Descriptions,
  Modal,
  Table
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from 'react-router-dom';

import memberService from "../../api/member.service";
import ProgrammeCommercialService from "../../api/programme.commercial.service";
import ProgrammeService from "../../api/programme.service";

import timeSlotService from "../../api/time.slot.service";

import {
  DATE_FORMAT_DMY_SLASH,
  SAVE_SUCCESS_MSG,
  SUCCESS_STATUS,
  ROUND_OFF_ACCOUNT_ID,
  MEMBER_ACCOUNT_ID,
  UPDATE_SUCCESS_MSG,
  BANK_CHARGES_ACCOUNT_ID,
  PAYMENT_SECTION_REQUIRED_MESSAGE,
  ADD_ONE_PAYMENT_MODE,
  ADD_TIME_SLOT_ERROR,
  JCP_PROGRAM_TAG
} from "../../utility/Constants";

import TimeSlotEnrollment from "./TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../api/enrollment.service";
import commonUtility from "../../utility/Utils";
import EnrollmentComponent from "./commercial-components/EnrollmentComponent";
import accountService from "../../api/account.service";
import OtherItems from "./commercial-components/OtherItems";
import TestFormItem from "./commercial-components/TestFormItem";
import PaymentComponent from "./commercial-components/PaymentComponent";
import paymentService from "../../api/payment.service";
import StudentCardInfo from "../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../common/ModalWithMessageAndAction";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;


const defaultFormValues = {
  mode: "UPDATE",
  enrollment_id: 0,
  member_id: 0,
  programme_id: '',
  group_id: "",
  day_slot: [],
};


const ScheduleChangeComp = () => {
  const [form] = Form.useForm();

  const params = useParams();
  let navigate = useNavigate();
  const state = useSelector((state)=>state.otheritem) 


  const [enrollmentID, setEnrollmentID] = useState(0);
  const [receiptID, setReceiptID] = useState(0);
  const [paymentID, setPaymentID] = useState(0);

  
  const [programmeList, setProgrammeList] = useState([]);
  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  



  const [programmeID, setProgrammeID] = useState([]);
  const [programmeGroupID, setProgrammeGroupID] = useState(0);

  const [previousTimeSlotList, setPreviousTimeSlotList] = useState([]);
  const [timeSlotList, setTimeSlotList] = useState([]);

  const [isFormChanged, setIsFormChanged] = useState(false);


  const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);



  // member Info
  const [memberDisplayInfo, setMemberDisplayInfo] = useState({
    memberName: '',
    memberPrimaryMobile: '',
    memberFatherName: '',
    memberDOB: '',
    profilePic: '',

  })

  const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({

    joinDate: '',
    validity: ''
  })


  const [openModal, setOpenModal] = useState(false);
  const [responseModalTitle, setResponseModalTitle] = useState("");
  const [responseModalMessage, setResponseModalMessage] = useState("");


  const onScheduleChangeUpdate = async (values) => {
    //setSaveLoaderEnable(true)

    setOpenModal(false);
    setResponseModalTitle("")
    setResponseModalMessage("")

    // e.preventDefault()
    const data = { formdata: values };
    console.log(data);
    //return false;

    // check atleast one payment mode


    if(values.day_slot.length > 0) {
      setSaveLoaderEnable(true)
      ProgrammeService.updateMemberTimeSlotDetails(data).then((res) => {
        
        if(res.data.response_status == SUCCESS_STATUS && res.data.response_data.affectedRows > 0) {
            setOpenModal(true)
            setResponseModalTitle("Success")
            setResponseModalMessage("Schedule successfully updated.")
        }
        else{
            setOpenModal(true)
            setResponseModalTitle("Error")
            setResponseModalMessage("There is some problem while updaing schedule.Try again later")
        }
        setSaveLoaderEnable(false)

      }).then(()=>{
        setSaveLoaderEnable(false)
      });
    }
    else {
      commonUtility.openNotificationWithType("error", "bottomRight", "Error", ADD_TIME_SLOT_ERROR);
    }
    




  };

  const onChange = (date, dateString) => {
   // console.log(date, dateString);
  };

 



  const onChangeCollapse = (key) => {
   // console.log(key);
  };
  const onSelectProgrammeGroup = (value, event) => {
    setProgrammeGroupID(value);
    form.setFieldsValue({ day_slot: [] });

  };

    const onProgramChange = (value, event) => {
        getMemberList();
        resetFieldsOnProgChange();
    };

  const getMemberList = () => {
    setMemberList([]);
    const data = { formdata: {
        programme_id:form.getFieldValue('programme_id')
    }}; 

    memberService.memberListByProgramme(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
        }
    });
  }


  useEffect(() => {
    ProgrammeService.programmeListForScheduleReport().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeList(res.data.response_data);
      }
    });
  }, []);


  useEffect(() => {
    ProgrammeService.programmeGroupList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeGroupList(res.data.response_data);
      }
    });
  }, []);






//   useEffect(() => {
//     const data = {
//       formdata: { short_code: "JCP" },
//     };
//     ProgrammeService.programmeByCode(data).then((res) => {
//       if (res.data.response_status === SUCCESS_STATUS) {
//         setProgrammeID(res.data.response_data[0].programme_id);
//         form.setFieldsValue({
//           programme_id: res.data.response_data[0].programme_id,
//         });
//       }
//     });
//   }, []);

 







  const onSelectMember = (value) => {
  
   // setIsAlreadyMemberEnrolled(false);
   // setAlreadyMemberEnrolledMessage("");
    form.setFieldsValue({
        member_id: 0,
        group_id: 0
    });

    const data = { formdata: { member_id: value, programme_id: form.getFieldValue('programme_id') } };
    ProgrammeService.checkMemberEnrolement(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const response = res.data.response_data;
        
        form.setFieldsValue({
          member_id: response.memberData[0].member_id,
          group_id:response.enrolmentData[0].group_id,
          enrollment_id:response.enrolmentData[0].enrollment_id,
        });


        setMemberDisplayInfo({
          memberName: `${response.memberData[0].member_fname} ${response.memberData[0].member_lname}`,
          memberPrimaryMobile: response.memberData[0].primary_mobile,
          memberFatherName: response.memberData[0].father_name,
          memberDOB: response.memberData[0].date_of_birth,
          profilePic: response.memberData[0].profile_picture,
        });

        setMemberDisplayOtherInfo({
            joinDate: response.enrolmentData[0].enrollment_start_date,
            validity: `${response.enrolmentData[0].enrollment_start_date} to ${response.enrolmentData[0].enrollment_end_date}`
          });
        //console.log("Enrolment date length",response.enrolmentData.length)

        setProgrammeGroupID(response.enrolmentData[0].group_id);

        getPreviousTimeSchedule();
      }
    });
  };




  const getPreviousTimeSchedule = () => {
    const data = {
        formdata: {
          enrollment_id: form.getFieldValue("enrollment_id"),
        },
      };

      timeSlotService.memberTimeSlotDetails(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const member_time_slot_details = res.data.response_data;
          setPreviousTimeSlotList(member_time_slot_details);
        }
      });
  }




  useEffect(() => {
    const data = {
      formdata: {
        programme_id: form.getFieldValue("programme_id"),
        programme_group_id: form.getFieldValue("group_id"),
      },
    };
    timeSlotService.timeSlotByProgrammeAndGroup(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setTimeSlotList(res.data.response_data);
      }
    });
  }, [programmeGroupID]);




  const handleCancel = () => {
    setOpenModal(false);
  };



  const resetFieldsOnProgChange = () => {
      form.setFieldsValue({
        enrollment_id : 0,
        member_id : '',
        group_id : '',
        member_search:''
      })
      setPreviousTimeSlotList([]);

      setMemberDisplayInfo({
        memberName: "",
        memberPrimaryMobile: "",
        memberFatherName: "",
        memberDOB: "",
        profilePic: "",
      });

      setMemberDisplayOtherInfo({
          joinDate: "",
          validity: ""
        });
      //console.log("Enrolment date length",response.enrolmentData.length)

      setProgrammeGroupID(0);
  } 

  function changeLocation(placeToGo){
    navigate(placeToGo, { replace: true });
    window.location.reload();
}

const columns = [
    {
      title: 'Group/Shift',
      dataIndex: 'programme_group',
      width:'15%'
    },
    {
      title: 'Day',
      dataIndex: 'day_name',
    },
    // {
    //     title: 'Time',
    //     dataIndex: 'time_slot',
    // },
];

  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col className="form-format-type1 enrollment-form jcp-enrollment" xs={24} xl={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onScheduleChangeUpdate}
            autoComplete="off"
            //initialValues={defaultValues}
            initialValues={defaultFormValues}
         
       
          >
            <Collapse
              bordered={false}
              defaultActiveKey={[
                "programme_jcp",
                "schedule_prv",
                "schedule_jcp",
               

              ]}
              onChange={onChangeCollapse}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <>
                    <h4>Programme</h4>
                  </>
                }
                key="programme_jcp"
                className="mainPanel"
              >
                <Row gutter={20}>
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>

                    <Col xs={6} xl={24}>
                                            <Form.Item
                                                name="programme_id"
                                                label="Programme"
                                                rules={[
                                                    {
                                                      required: true,
                                                      message: "Select Programme",
                                                    },
                                                  ]}

                                            >
                                                <Select className="text-left"
                                                        onSelect={(value, event) =>
                                                        onProgramChange(value, event)
                                                    }
                                                >
                                                    <Option value="">Select</Option>
                                                    {programmeList.length > 0
                                                        ? programmeList.map((programme_list) => (
                                                            <Option
                                                                key={programme_list.programme_id}
                                                                value={programme_list.programme_id}
                                                            >
                                                                {programme_list.programme_name}
                                                            </Option>
                                                        ))
                                                        : ""}
                                                </Select>
                                            </Form.Item>
                                        </Col>

                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          name="member_search"
                          label="Search (Name | Mobile no | Father Name)"
                          rules={[
                            {
                              required: true,
                              message: "Select Member ",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              //option.children.includes(input)
                              option.children.toLowerCase().includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            onSelect={(value, event) =>
                              onSelectMember(value, event)
                            }
                          >
                            {memberList.length > 0
                              ? memberList.map((member_list) => (
                                <Option
                                  key={member_list.member_id}
                                  value={member_list.member_id}
                                >
                                  {`${member_list.member_fname} ${member_list.member_lname
                                    } | ${member_list.primary_mobile}  ${member_list.father_name != null
                                      ? member_list.father_name
                                      : ""
                                    }`}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item name="enrollment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="member_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="programme_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                       
                        <Form.Item name="entry_from" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                       
                   
    
              
                        {/* <Form.Item name="dr_ac_id" hidden={true}>
                                            <Input type="text" />
                                        </Form.Item> */}
                      </Col>

                      {/* <Col xs={24} xl={24}>
                        <Form.Item
                          name="group_id"
                          label="Programme Group (Shift)"
                          rules={[
                            {
                              required: true,
                              message: "Select Group",
                            },
                          ]}
                        >
                          <Select
                            className="text-left"
                            onSelect={(value, event) =>
                              onSelectProgrammeGroup(value, event)
                            }
                          >
                            <Option value="">Select</Option>
                            {programmeGroupList.length > 0
                              ? programmeGroupList.map((programme_group_list) => (
                                <Option
                                  key={programme_group_list.programme_group_id}
                                  value={programme_group_list.programme_group_id}
                                >
                                  {programme_group_list.programme_group}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col> */}

                  
                 
                  


                      

                    </Row>

                  </Col> {/** end of column */}
                  <Col xs={24} xl={12}>

                    <Row gutter={20}>
                      <Col xs={24} xl={24}>

                        <StudentCardInfo memberDisplayInfo={memberDisplayInfo} memberDisplayOtherInfo={memberDisplayOtherInfo} />

                      </Col>
                    </Row>


                  </Col>



                  
                </Row>


              </Panel>


             
              <Panel
                header={
                  <>
                    <h4>Previous Schedule</h4>
                  </>
                }
                key="schedule_prv"
                className="mainPanel"
              >
                <Table columns={columns} dataSource={previousTimeSlotList} pagination={false} key={commonUtility.randomID()} size="small"/>
              </Panel>

              <Panel
                header={
                  <>
                    <h4>Add New Schedule</h4>
                  </>
                }
                key="schedule_jcp"
                className="mainPanel"
              >

                <Row>
                <Col xs={6} xl={6}>
                        <Form.Item
                          name="group_id"
                          label="Programme Group (Shift)"
                          rules={[
                            {
                              required: true,
                              message: "Select Group",
                            },
                          ]}
                        >
                          <Select
                            className="text-left"
                            onSelect={(value, event) =>
                              onSelectProgrammeGroup(value, event)
                            }
                          >
                            <Option value="">Select</Option>
                            {programmeGroupList.length > 0
                              ? programmeGroupList.map((programme_group_list) => (
                                <Option
                                  key={programme_group_list.programme_group_id}
                                  value={programme_group_list.programme_group_id}
                                >
                                  {programme_group_list.programme_group}
                                </Option>
                              ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>
                </Row>
                {/* <TimeSlotEnrollment mode={form.getFieldValue("mode")} timeSlotListData={timeSlotList} /> */}
                <TimeSlotEnrollment mode={form.getFieldValue("mode")} 
                                timeSlotListData={timeSlotList} 
                                key={commonUtility.randomID()} 
                                isDayRequired={true} 
                                isDayTimeRequired={false} 
                                module={JCP_PROGRAM_TAG} />
              </Panel>

   
            </Collapse>




                <Row justify="end">
                  <Col>
                    <Form.Item>
                        <Button
                            htmlType="submit"
                            shape="round"
                            className="custom-button-green"
                          >
                            Update <RightOutlined />
                        </Button>
                    </Form.Item>
                  </Col>
                </Row>

          </Form>
        </Col>
      </Row>



      <Modal
        title={responseModalTitle}
        centered
        visible={openModal}
        open={openModal}
            closable={false}
        footer={[
         
          
          <Link to={`/schedule/time-schedule-report`} style={{margin:1}} >
            <Button htmlType="button" type="primary" size="small"> <EyeOutlined /> View Schedule List</Button>
          </Link>,

          <Link to={`/schedule/change-schedule/`} style={{margin:1}} >
            <Button htmlType="button" type="danger"  size="small"> <EyeOutlined /> Change More Schedule</Button>
          </Link>,
          
          // <Button key="submit" type="danger" onClick={()=> resetFormFields() }  style={{margin:1}} >
          //   <PlusOutlined /> Add More
          // </Button>,
        ]}
        style={{width:'200px'}}
        className='responseModal'
      >
        <div style={{textAlign:'center'}}>
          <CheckCircleTwoTone twoToneColor="#52c41a" style={{fontSize:'2.5rem'}} />
          <h3>{responseModalMessage}</h3>
        </div>

      </Modal>



    </div>
  );
};
export default ScheduleChangeComp;
